import React, { FC } from "react";
import { Collapse, CollapseProps, useTheme } from "@mui/material";

interface CollapseChildrenProps extends CollapseProps {
  show: boolean;
  children: React.ReactNode;
  initialMargin?: number;
  hasNextNode?: boolean;
}

const CollapseChildren: FC<CollapseChildrenProps> = ({
  children,
  show,
  initialMargin,
  hasNextNode,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Collapse
      in={show}
      collapsedSize={props.collapsedSize}
      timeout={theme.transitions.getAutoHeightDuration(250)}
      sx={{
        mt: "0 !important",
        pt: show ? "16px" : 0,
        transition: `all cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
        width: "100%",
        opacity: show ? 1 : 0,
      }}
    >
      {children}
    </Collapse>
  );
};

export default CollapseChildren;
